module.exports = __webpack_public_path__ + "img/kk-logo-white.dbc52452.png";